import { BadgeSize, BadgeVariant } from './types'

const BADGE_DEFAULT_SIZE: BadgeSize = 'small' as const
const BADGE_DEFAULT_VARIANT: BadgeVariant = 'default' as const

export { BADGE_DEFAULT_SIZE, BADGE_DEFAULT_VARIANT }
